import { useContext } from 'react';
import { AppContext, EMPTY_OBJECT } from 'commons-ui';

import { URL, APK_UPDATE_RESOURCES } from '../../helper';
import useService from '../../useService';

export const makeActionHandler = (action: any, params: any) => {
	const { history, rowData = EMPTY_OBJECT, setShowLoader, setForceUpdateRows, setConfirmationDialog } = params;
	const { showAlert } = useContext(AppContext);
	const { requestToggleAppUpdateInfo, deleteSuperAppUpdate } = useService();

	switch (action.id) {
		case 'edit':
			return () => {
				history.push({
					pathname: `${URL[APK_UPDATE_RESOURCES.appUpdateInfo]}/edit`,
					state: {
						rowData
					}
				});
			};
		case 'clone':
			return () => {
				history.push({
					pathname: `${URL[APK_UPDATE_RESOURCES.appUpdateInfo]}/clone`,
					state: {
						rowData
					}
				});
			};
		case 'add':
			return () => {
				history.push({
					pathname: `${URL[APK_UPDATE_RESOURCES.appUpdateInfo]}/create`
				});
			};

		case 'remove': {
			const deleteSuperAppUpdateData = async () => {
				await deleteSuperAppUpdate(rowData);
				setForceUpdateRows(true);
			};

			return () => {
				setConfirmationDialog({
					show: true,
					header: 'Remove this app update?',
					handleAlertConfirmation: deleteSuperAppUpdateData
				});
			};
		}

		case 'updates_off': {
			const toggleIsDisabled = async () => {
				setShowLoader(true);
				try {
					await requestToggleAppUpdateInfo(rowData._id);
					showAlert('Updates are switched off for this version');
				} catch (err: any) {
					showAlert(`Error: ${err.response.data.error}`, { type: 'error' });
				}
				setShowLoader(false);
			};

			return () => {
				setConfirmationDialog({
					show: true,
					header: 'Please Confirm',
					message: 'Are you sure you want switch off updates for this version?',
					handleAlertConfirmation: toggleIsDisabled
				});
			};
		}

		case 'updates_on': {
			const toggleIsDisabled = async () => {
				setShowLoader(true);
				try {
					await requestToggleAppUpdateInfo(rowData._id);
					showAlert('Updates are switched on for this version');
				} catch (err: any) {
					showAlert(`Error: ${err.response.data.error}`, { type: 'error' });
				}
				setShowLoader(false);
			};

			return () => {
				setConfirmationDialog({
					show: true,
					header: 'Please Confirm',
					message: 'Are you sure you want switch on updates for this version?',
					handleAlertConfirmation: toggleIsDisabled
				});
			};
		}
		default:
			return () => {};
	}
};

export default {
	makeActionHandler
};
